<template>
  <div
    class="single_head_banner"
    :class="{ no_paddings: conf, no_text: conf_2 }"
  >
    <div class="single_head_banner__inner container" v-if="!conf">
      <div class="single_head_banner__img_wrapper br-12">
        <div class="bg-overlay"></div>
        <picture>
          <source
            media="(max-width: 767px)"
            :srcset="_.get(content.images[0], 'devices.mobile')"
          />
          <source
            media="(max-width: 1023px)"
            :srcset="_.get(content.images[0], 'devices.tablet')"
          />
          <img
            :src="_.get(content.images[0], 'devices.desktop')"
            :alt="
              $route.name == 'PageViewRouter_ge'
                ? content.seo_keywords_ge
                : content.seo_keywords_en
            "
            class="cover"
          />
        </picture>
        <div class="single_head_banner__text-box flex column wc-lg">
          <h2 class="f-55 bold f-white">{{ _.get(content, "title") }}</h2>
          <p class="f-18 regular f-white" v-if="windowWidth >= 768">
            {{ _.get(content, "teaser") }}
          </p>
          <router-link
            :to="_.get(content, 'link')"
            class="single_head_banner__btn button bg-white"
          >
            <svg
              id="Group_5_Copy_3"
              data-name="Group 5 Copy 3"
              xmlns="http://www.w3.org/2000/svg"
              width="11.352"
              height="11.351"
              viewBox="0 0 11.352 11.351"
            >
              <path
                id="Combined_Shape_Copy_2"
                data-name="Combined Shape Copy 2"
                d="M5.007,11.074a.946.946,0,0,1,0-1.338L8.122,6.622H.946a.946.946,0,0,1,0-1.892H8.121L5.007,1.615A.946.946,0,1,1,6.344.277l4.73,4.729.016.017.008.009.008.008.01.011.006.006.011.012,0,0,.011.014,0,0,.011.014,0,0,.011.015,0,0,.01.015,0,0,.009.014,0,.005.008.013,0,.007.007.011.006.01,0,.009.007.013,0,.006.009.017v0a.946.946,0,0,1-.194,1.1L6.344,11.074a.946.946,0,0,1-1.338,0Z"
                fill="#613dd1"
              />
            </svg>
            <span class="f-14 bold uppercase f-light-purple">{{
              _.get(content, "link_name")
            }}</span>
          </router-link>
        </div>
      </div>
    </div>

    <div class="single_head_banner__inner" v-if="conf">
      <div class="single_head_banner__img_wrapper">
        <div class="bg-overlay" v-if="!conf_2"></div>
        <picture>
          <source
            media="(max-width: 767px)"
            :srcset="_.get(content.images[0], 'devices.mobile')"
          />
          <source
            media="(max-width: 1023px)"
            :srcset="_.get(content.images[0], 'devices.tablet')"
          />
          <img
            :src="_.get(content.images[0], 'devices.desktop')"
            :alt="
              $route.name == 'PageViewRouter_ge'
                ? content.seo_keywords_ge
                : content.seo_keywords_en
            "
            class="cover"
            data-scroll
            data-scroll-speed="-1.4"
          />
        </picture>
      </div>
      <div class="single_head_banner__text-box-wrapper">
        <div class="single_head_banner__text-box-wrapper--inner">
          <div
            class="single_head_banner__text-box flex column wc-lg"
            v-if="!conf_2"
          >
            <h2 class="f-55 bold f-white">{{ _.get(content, "title") }}</h2>
            <p class="f-18 regular f-white" v-if="windowWidth >= 768">
              {{ _.get(content, "teaser") }}
            </p>
            <router-link
              :to="_.get(content, 'link')"
              class="single_head_banner__btn button bg-white"
            >
              <svg
                id="Group_5_Copy_3"
                data-name="Group 5 Copy 3"
                xmlns="http://www.w3.org/2000/svg"
                width="11.352"
                height="11.351"
                viewBox="0 0 11.352 11.351"
              >
                <path
                  id="Combined_Shape_Copy_2"
                  data-name="Combined Shape Copy 2"
                  d="M5.007,11.074a.946.946,0,0,1,0-1.338L8.122,6.622H.946a.946.946,0,0,1,0-1.892H8.121L5.007,1.615A.946.946,0,1,1,6.344.277l4.73,4.729.016.017.008.009.008.008.01.011.006.006.011.012,0,0,.011.014,0,0,.011.014,0,0,.011.015,0,0,.01.015,0,0,.009.014,0,.005.008.013,0,.007.007.011.006.01,0,.009.007.013,0,.006.009.017v0a.946.946,0,0,1-.194,1.1L6.344,11.074a.946.946,0,0,1-1.338,0Z"
                  fill="#613dd1"
                />
              </svg>
              <span class="f-14 bold uppercase f-light-purple uppercase">{{
                _.get(content, "link_name")
              }}</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import resize_handler from "@/mixins/resize_handler";
export default {
  props: ["contentData"],
  mixins: [resize_handler],
  computed: {
    content() {
      return _.get(this.contentData, "data.list[0]");
    },
    conf() {
      let conf = _.get(this.contentData, "conf.conf");
      conf = conf.filter(cf => cf == "no_paddings");
      return conf[0];
    },
    conf_2() {
      let conf = _.get(this.contentData, "conf.conf");
      conf = conf.filter(cf => cf == "no_text");
      return conf[0];
    }
  },
  mounted() {
    console.log(this.content);
  }
};
</script>

<style></style>
